import React, {useState} from "react";
import NotFoundPage from "../layouts/404";
import Admin from './admin/Admin';
import Curator from "./curator/Curator";
import Moderator from "./moderator/Moderator";
import Student from "./student/Student";
import Teacher from "./teacher/Teacher";
import Expert from './expert/Expert';

import './profile.css'
import './add.css'
import Instructions from "./Instructions";

export default function Profile({mainState, updateProfile}) {
  const [status,setStatus]=useState(sessionStorage.getItem('instructionStatus')||false)
  const statusHandler =(status)=>{
    setStatus(status)
    sessionStorage.setItem('instructionStatus',status); // Сохраняем значение в Session Storage
  }
  if (mainState.isLoggedIn) {
    if(!status){
      return <Instructions setStatus={statusHandler}/>
    }
    switch(mainState.type){
		case 'Admin':
			return <Admin/>
    case 'Student':
      return <Student/>
    case 'Curator':
      return <Curator/>
    case 'Teacher':
      return <Teacher/>
    case 'Editor':
      return <Moderator/>
    case 'Expert':
      return <Expert/>
      case 'SuperExpert':
        return <Expert/>
    default:
      return <NotFoundPage/>
  }
  }
  return <NotFoundPage/>

}